import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  showNotification as shn,
  fetchStart as fs,
  fetchEnd as fe,
} from "react-admin";

import { pauseAllKiosks } from "../lib/serverCommands";
import { getStationId } from "../authProvider";

const handleClick = (
  selectedIds,
  { showNotification, fetchStart, fetchEnd }
) => {
  fetchStart();
  pauseAllKiosks(getStationId())
    .then(() => showNotification("notification.endOfSell"))
    .catch(err => {
      showNotification("notification.errorSending"); // TODO: message
      console.error("Error sending multiple pause kiosk message", err);
    })
    .finally(fetchEnd);
};

const PauseAllButton = ({ selectedIds, ...props }) => (
  <Button label="Tout Pause" onClick={() => handleClick(selectedIds, props)} />
);

const styles = () => ({
  container: {
    display: "flex",
  },
});

export default connect(
  null,
  {
    showNotification: shn,
    fetchStart: fs,
    fetchEnd: fe,
  }
)(withStyles(styles)(PauseAllButton));



// WEBPACK FOOTER //
// ./src/components/pauseAllButton.js